// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"62a8b8cd","151":"e7a83776","169":"34ddca05","453":"4cc95e40","691":"05892067","832":"171a4039","901":"580cb91b"}[chunkId] + ".chunk.js";
};